import { render, staticRenderFns } from "./PageList_Search.vue?vue&type=template&id=2b6a77db"
import script from "./PageList_Search.vue?vue&type=script&lang=js"
export * from "./PageList_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports